import React, { useState, useEffect } from 'react'
// eslint-disable-next-line
import styles from './index.module.less'
import { useNavigate, useLocation } from 'react-router-dom'
//import { TranslationOutlined } from '@ant-design/icons'
import { Menu } from 'antd'
const items = [
  {
    label: (
      <a style={{ color: '#ffffff' }} href='http://huiyuexpo.com' target='_blank' rel='noreferrer'>主办方</a>
    ),
    key: 'zbf'
  },
  {
    label: '首页',
    key: 'sy'
  },
  {
    label: '会议',
    key: 'hyyc',
    children: [
      {
        label: '会议',
        key: 'hy'
      },
      // {
      //   label: '议程',
      //   key: 'yc'
      // }
    ]
  },
  {
    label: '演讲嘉宾',
    key: 'yjjb'
  },
  // {
  //   label: '新闻',
  //   key: 'xw'
  // },

  // {
  //   label: '报名',
  //   key: 'bm'
  // },

  // {
  //   label: '合作伙伴',
  //   key: 'home',
  //   children: [
  //     {
  //       label: '赞助商',
  //       key: 'zzs'
  //     },
  //     {
  //       label: '媒体',
  //       key: 'mt'
  //     }
  //   ]
  // },
  // {
  //   label: '关于',
  //   key: 'gy',
  //   children: [
  //     // {
  //     //   label: '资料下载',
  //     //   key: 'zlxz'
  //     // },
  //     {
  //       label: '联系',
  //       key: 'lx'
  //     }
  //   ]
  // }
]
export default function Header() {
  const path = useLocation().pathname
  const navigate = useNavigate()
  const [current, setCurrent] = useState('sy')
  const click = (e) => {
    setCurrent(e.key)
    switch (e.key) {
      case 'hy':
        navigate('/meeting')
        break;
      case 'lx':
        navigate('/contact')
        break;
      case 'zlxz':
        navigate('/download')
        break;
      case 'xw':
        navigate('/news')
        break;
      case 'mt':
        navigate('/media')
        break;
      case 'zzs':
        navigate('/vendors')
        break;
      case 'bm':
        navigate('/enroll')
        break;
      case 'yjjb':
        navigate('/guests')
        break;
      case 'yc':
        navigate('/agenda')
        break;
      default:
        navigate('/')
        break;
    }
  }
  useEffect(() => {
    switch (path) {
      case '/home':
        setCurrent('sy')
        break;
      case '/news':
        setCurrent('xw')
        break;
      case '/enroll':
        setCurrent('bm')
        break;
      case '/contact':
        setCurrent('lx')
        break;
      case '/guests':
        setCurrent('yjjb')
        break;
      case '/guests/detail':
        setCurrent('yjjb')
        break;
      case '/vendors':
        setCurrent('zzs')
        break;
      default:
        break;
    }
  }, [path])
  return (
    <nav>
      <a href="/">
        <img src="/logo.png" alt="" />
      </a>
      <Menu
        selectable={false}
        style={{ justifyContent: 'center', backgroundColor: 'transparent', color: 'white' }}
        mode='horizontal'
        items={items}
        selectedKeys={current}
        onClick={click} />
      {/* <TranslationOutlined className={styles.lang} /> */}
    </nav>
  )
}
